// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Override style coming from react-widgets */

.rw-multiselect-tag-btn svg {
	vertical-align: -2px;
}`, "",{"version":3,"sources":["webpack://./main/stats.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;CACC,oBAAoB;AACrB","sourcesContent":["/* Override style coming from react-widgets */\n\n.rw-multiselect-tag-btn svg {\n\tvertical-align: -2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
